import { configureStore } from '@reduxjs/toolkit';
import errorReducer from './error';
import userReducer from './user';
import organizationReducer from './organization';

export const store = configureStore({
    reducer: {
        error: errorReducer,
        user: userReducer,
        organization: organizationReducer
    }
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;